export { default as getVendorListJson } from './utils/getvendorlist';
